
function showFullScreen() {
  	screenType = "fullscreen";
	showOneButtonStandard(textScreens[screenType][language][0]);
	$('#button1').css('top','50%');
}


function enterFullScreen() {
	var docElm = document.documentElement;
	if (docElm.requestFullscreen) {
    	docElm.requestFullscreen();
	}
	else if (docElm.mozRequestFullScreen) {
	    docElm.mozRequestFullScreen();
	}
	else if (docElm.webkitRequestFullScreen) {
	    docElm.webkitRequestFullScreen();
	}
	else if (docElm.msRequestFullscreen) {
	    docElm.msRequestFullscreen();
	}
	screen_fullscreen = false;
 	setTimeout(function() {main()}, 50);
}

